import { jsx } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import "../../../../external/luxon/src/duration.js";
import Settings from "../../../../external/luxon/src/settings.js";
import Info from "../../../../external/luxon/src/info.js";
import "../../../../external/luxon/src/impl/regexParser.js";
import { useMemo } from "react";
const WeekDaysStripe = () => {
  const weekDays = useMemo(() => {
    const weekdays = Info.weekdays("short", {
      locale: Settings.defaultLocale
    }).map((d) => d.slice(0, 2));
    return /-us/i.test(Settings.defaultLocale) && weekdays.unshift(...weekdays.splice(-1, 1)), weekdays;
  }, []);
  return /* @__PURE__ */ jsx(Stack, { direction: "row", children: weekDays.map((d) => /* @__PURE__ */ jsx(Stack, { sx: st.cell, children: /* @__PURE__ */ jsx(Typography, { sx: st.txt, children: d }) }, d)) });
}, st = {
  cell: {
    "--size": "42px",
    width: "var(--size)",
    height: "var(--size)",
    alignItems: "center",
    justifyContent: "start",
    color: (t) => t.palette.picker.primary.content,
    paddingTop: 8,
    boxSizing: "border-box"
  },
  txt: {
    fontSize: "14px",
    lineHeight: "18px",
    fontWeight: 500,
    color: (t) => t.palette.picker.primary.content
  }
};
export {
  WeekDaysStripe
};
//# sourceMappingURL=WeekDaysStripe.js.map
